// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import EnergyTreeNodeComparisonAnalysisPage from '@/features/energyxplorer/components/analysis/EnergyTreeNodeComparisonAnalysisPage';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/comparison-analysis',
)({
  component: EnergyTreeNodeComparisonAnalysisPage,
});
